import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import Follow from '~/components/profile/Follow.vue';
import WebpPicture from '~/components/WebpPicture.vue';
import debounce from '~/utilities/debounce.js';
export default {
  components: {
    Follow: Follow,
    WebpPicture: WebpPicture,
    UsersSkeleton: function UsersSkeleton() {
      return import('~/components/panels/UsersSkeleton.vue');
    }
  },
  data: function data() {
    return {
      search: ''
    };
  },
  computed: {
    usersListStore: function usersListStore() {
      return useUsersListStore();
    },
    users: function users() {
      return this.usersListStore.users;
    },
    length: function length() {
      return this.usersListStore.length;
    },
    title: function title() {
      return this.usersListStore.title;
    },
    isBottom: function isBottom() {
      return (this.length || 0) <= this.users.length;
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.observer = new IntersectionObserver(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        entry = _ref2[0];
      if (entry && entry.isIntersecting) {
        _this.usersListStore.load(_this.defActive);
      }
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    });
    setTimeout(function () {
      var el = document.getElementById('users-list-bottom');
      if (el) _this.observer.observe(el);
    }, 300);
  },
  methods: {
    load: function load(name) {
      if (this.list[name].list.length >= this.list[name].length) return;
      this.usersListStore.load(name);
    },
    debounceSearch: debounce(function () {
      this.usersListStore.search(this.search);
    }, 300)
  },
  destroyed: function destroyed() {
    if (this.observer) this.observer.disconnect();
  }
};